import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';

/**
 * Renders a supported `{{variable}}` placeholder as a non-editable inline pill.
 *
 * The node is an atom (see VariableNode), so the user can select and delete it
 * as a single unit but cannot type inside it. The pill carries NO horizontal
 * padding (ENG-3184): its visible width matches the token exactly, so real
 * spaces around it are faithfully represented instead of being faked by padding.
 */
export const VariablePill = ({ node, selected }: NodeViewProps) => {
  const { id } = node.attrs;

  return (
    <NodeViewWrapper
      as="span"
      // `selected` is true when the atom node is the active node selection
      // (clicked, or reached via arrow keys), so the user can see where the
      // cursor is.
      className={`variable-pill${selected ? ' variable-pill--selected' : ''}`}
      contentEditable={false}
      data-variable-id={id}
    >
      {`{{${id}}}`}
    </NodeViewWrapper>
  );
};
